/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type WorkOrderSingleDeletionMutationVariables = Types.Exact<{
  input: Types.DeleteWorkOrderInput
}>

export type WorkOrderSingleDeletionMutation = {
  __typename?: 'Mutation'
  deleteWorkOrder: { __typename?: 'DeleteWorkOrderResponse'; success: boolean }
}

export const WorkOrderSingleDeletionDocument = gql`
    mutation WorkOrderSingleDeletion($input: DeleteWorkOrderInput!) {
  deleteWorkOrder(input: $input) {
    success
  }
}
    `
export type WorkOrderSingleDeletionMutationFn = Apollo.MutationFunction<
  WorkOrderSingleDeletionMutation,
  WorkOrderSingleDeletionMutationVariables
>

/**
 * __useWorkOrderSingleDeletionMutation__
 *
 * To run a mutation, you first call `useWorkOrderSingleDeletionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWorkOrderSingleDeletionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [workOrderSingleDeletionMutation, { data, loading, error }] = useWorkOrderSingleDeletionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWorkOrderSingleDeletionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    WorkOrderSingleDeletionMutation,
    WorkOrderSingleDeletionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    WorkOrderSingleDeletionMutation,
    WorkOrderSingleDeletionMutationVariables
  >(WorkOrderSingleDeletionDocument, options)
}
export type WorkOrderSingleDeletionMutationHookResult = ReturnType<
  typeof useWorkOrderSingleDeletionMutation
>
export type WorkOrderSingleDeletionMutationResult =
  Apollo.MutationResult<WorkOrderSingleDeletionMutation>
export type WorkOrderSingleDeletionMutationOptions = Apollo.BaseMutationOptions<
  WorkOrderSingleDeletionMutation,
  WorkOrderSingleDeletionMutationVariables
>
